import ICommand from '../FrontApplet/Command/ICommand';
import { ITypedCommandEvent } from '../FrontApplet/Command/ICommandEvent';
import FrontApplet from '../FrontApplet/FrontApplet';
import {
	AppletMonitoringRequests,
	AppletRefreshRequest,
	AppletRefreshResult,
	AppletRestoreRequest,
	AppletRestoreResult,
	DisableMonitoring,
	EnableMonitoring,
} from './monitoringCommands';

export function handleMonitoringRequests(
	onCommand: (callback: (commandEvent: ITypedCommandEvent<AppletMonitoringRequests>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => Promise<void>,
	frontApplet: FrontApplet,
) {
	onCommand(async (commandEvent: ITypedCommandEvent<AppletMonitoringRequests>) => {
		switch (commandEvent.command.type) {
			case EnableMonitoring:
				frontApplet.config.sosMonitoring = true;
				break;
			case DisableMonitoring:
				frontApplet.config.sosMonitoring = false;
				break;
			case AppletRefreshRequest:
				await frontApplet.refresh();
				await dispatch<AppletRefreshResult>({
					type: AppletRefreshResult,
					result: {},
				});
				break;
			case AppletRestoreRequest:
				await dispatch<AppletRestoreResult>({
					type: AppletRestoreResult,
					result: {},
				});
				frontApplet.restore();
				break;
			default:
		}
	});
}
